export const en = {
  'shell.nav.recruiting': 'Recruiting',
  'shell.nav.recruitingOpenings': 'Job openings',
  'shell.nav.recruitingCandidates': 'Candidates',
  'shell.nav.recruitingInterviews': 'My interviews',
  'enum.candidateStage.APPLIED': 'Applied',
  'enum.candidateStage.SCREENING': 'Screening',
  'enum.candidateStage.INTERVIEW': 'Interview',
  'enum.candidateStage.OFFER': 'Offer',
  'enum.candidateStage.HIRED': 'Hired',
  'enum.candidateStage.REJECTED': 'Rejected',
  'enum.openingStatus.OPEN': 'Open',
  'enum.openingStatus.CLOSED': 'Closed',

  'recruiting.openings.title': 'Job openings',
  'recruiting.openings.description': 'An open job is listed on the careers page of your website with an application form that takes a CV.',
  'recruiting.openings.add': 'New opening',
  'recruiting.openings.empty': 'No job openings yet',
  'recruiting.openings.emptyHint': 'Post your first job and it appears on the careers page of your website.',
  'recruiting.opening.job': 'Job',
  'recruiting.opening.branch': 'Branch',
  'recruiting.opening.department': 'Department',
  'recruiting.opening.type': 'Type',
  'recruiting.opening.status': 'Status',
  'recruiting.opening.candidates': 'Candidates',
  'recruiting.opening.anyBranch': 'Any branch',
  'recruiting.opening.noDepartment': 'No department',
  'recruiting.opening.candidateCount': '{total} in all, {open} in progress',
  'recruiting.opening.noCandidates': 'None yet',
  'recruiting.opening.viewCandidates': 'View candidates',
  'recruiting.opening.edit': 'Edit',
  'recruiting.opening.close': 'Close opening',
  'recruiting.opening.reopen': 'Reopen',
  'recruiting.opening.created': 'Opening posted',
  'recruiting.opening.saved': 'Opening saved',
  'recruiting.opening.closed': 'Opening closed. It no longer takes applications.',
  'recruiting.opening.reopened': 'Opening reopened',
  'recruiting.opening.newTitle': 'New job opening',
  'recruiting.opening.editTitle': 'Edit job opening',
  'recruiting.opening.dialogHint': 'Write it in both languages. Visitors read the language of the page they are on.',
  'recruiting.opening.titleField': 'Job title',
  'recruiting.opening.descriptionField': 'Description',
  'recruiting.opening.descriptionHint': 'What the job involves, the hours, and what you ask for.',
  'recruiting.opening.titleRequired': 'Give the title in at least one language',
  'recruiting.opening.statusField': 'Status',
  'recruiting.opening.statusHint': 'Only an open job is listed on the website and takes applications.',

  'recruiting.retention.title': 'Keeping applications',
  'recruiting.retention.description': 'A candidate you reject is deleted with their CV once this time has passed. People you are still considering, and people you hired, stay.',
  'recruiting.retention.months': 'Months to keep a rejected candidate',
  'recruiting.retention.hint': 'From 1 to 60 months. A daily job does the deleting and writes it to the audit log.',
  'recruiting.retention.saved': 'Retention saved',

  'recruiting.candidates.title': 'Candidates',
  'recruiting.candidates.description': 'Everyone who applied, from the application to the hire. Drag a card to the next stage.',
  'recruiting.candidates.search': 'Search by name, email or phone',
  'recruiting.candidates.allOpenings': 'All openings',
  'recruiting.candidates.empty': 'No applications yet',
  'recruiting.candidates.emptyHint': 'Applications sent from the careers page of your website appear here.',
  'recruiting.candidates.noMatch': 'No candidates match',
  'recruiting.candidates.noMatchHint': 'Try another search or another opening.',
  'recruiting.candidates.clear': 'Clear filters',
  'recruiting.candidates.descriptionList': 'Everyone who applied, newest first. Open a candidate to see the application and the CV.',
  'recruiting.candidates.allStages': 'All stages',
  'recruiting.view.label': 'View',
  'recruiting.view.board': 'Board',
  'recruiting.view.list': 'List',
  'recruiting.list.stage': 'Stage',
  'recruiting.list.applied': 'Applied on',
  'recruiting.list.deletion': 'Deleted on',
  'recruiting.board.label': 'Candidate pipeline',
  'recruiting.board.empty': 'Nobody here',
  'recruiting.board.more': '{count} more not shown',
  'recruiting.board.handle': 'Move {name}',
  'recruiting.board.instructions': 'Press space to pick up a candidate, the left and right arrows to choose a stage, space to drop.',
  'recruiting.board.picked': '{name} picked up from {stage}.',
  'recruiting.board.over': '{name} is over {stage}.',
  'recruiting.board.dropped': '{name} dropped on {stage}.',
  'recruiting.board.cancelled': '{name} stays at {stage}.',
  'recruiting.card.interview': 'Interview {when}',
  'recruiting.card.rating': '{rating} of 5',
  'recruiting.card.cv': 'CV attached',
  'recruiting.card.deletedOn': 'Deleted {date}',
  'recruiting.moved': '{name} moved to {stage}',

  'recruiting.interviews.title': 'My interviews',
  'recruiting.interviews.description': 'Candidates you are named to interview. Open one to read the application and the CV.',
  'recruiting.interviews.empty': 'No interviews yet',
  'recruiting.interviews.emptyHint': 'When someone names you as a candidate’s interviewer, that candidate appears here.',
  'recruiting.interviews.noDate': 'No date set',
  'recruiting.interviews.noCv': 'No CV',
  'recruiting.interviews.back': 'Back to my interviews',

  'recruiting.reject.title': 'Reject {name}',
  'recruiting.reject.description': 'The reason stays on their timeline. Their details and CV are deleted {months} months from now.',
  'recruiting.reject.label': 'Reason',
  'recruiting.reject.placeholder': 'Why they are not going forward',
  'recruiting.reject.confirm': 'Reject',
  'recruiting.interview.title': 'Interview with {name}',
  'recruiting.interview.description': 'Say when it is and who talks to them.',
  'recruiting.interview.when': 'Date and time',
  'recruiting.interview.who': 'Interviewer',
  'recruiting.interview.nobody': 'Not decided yet',
  'recruiting.interview.confirm': 'Save interview',
  'recruiting.interview.change': 'Change interview',

  'recruiting.hire.action': 'Hire',
  'recruiting.hire.title': 'Hire {name}',
  'recruiting.hire.description': 'This adds them to Team → Employees. The details come from the application and the job; check them.',
  'recruiting.hire.required': 'Required',
  'recruiting.hire.firstName': 'First name',
  'recruiting.hire.lastName': 'Last name',
  'recruiting.hire.position': 'Position',
  'recruiting.hire.department': 'Department',
  'recruiting.hire.noDepartment': 'No department',
  'recruiting.hire.branch': 'Branch',
  'recruiting.hire.everyBranch': 'Every branch',
  'recruiting.hire.type': 'Employment type',
  'recruiting.hire.startDate': 'Start date',
  'recruiting.hire.invite': 'Also invite them to sign in',
  'recruiting.hire.inviteHint': 'They get an email to create an account at this gym with the role below.',
  'recruiting.hire.inviteNeedsEmail': 'Add an email address to invite them.',
  'recruiting.hire.role': 'Role',
  'recruiting.hire.branches': 'Works at',
  'recruiting.hire.branchRequired': 'Choose at least one branch',
  'recruiting.hire.confirm': 'Hire',
  'recruiting.hire.done': '{name} is now an employee.',
  'recruiting.hire.openEmployee': 'Open the employee',
  'recruiting.hire.inviteSent': 'An invitation was emailed. You can also share this link.',
  'recruiting.hire.attached': 'They already had an account here, so the role was applied at once.',

  'recruiting.candidate.back': 'Back to candidates',
  'recruiting.candidate.moveTo': 'Move to',
  'recruiting.candidate.appliedFor': 'Applied for {job} on {date}',
  'recruiting.candidate.application': 'Application',
  'recruiting.candidate.message': 'Message',
  'recruiting.candidate.noMessage': 'They did not write a message.',
  'recruiting.candidate.consent': 'Agreed to the gym keeping their data on {date}.',
  'recruiting.candidate.cv': 'CV',
  'recruiting.candidate.noCv': 'No CV was sent.',
  'recruiting.candidate.openCv': 'Open CV',
  'recruiting.candidate.cvNote': 'Opens a private link that works for five minutes. Opening it is recorded in the audit log.',
  'recruiting.candidate.cvFailed': 'The CV could not be opened',
  'recruiting.candidate.interview': 'Interview',
  'recruiting.candidate.interviewAt': '{when}, with {name}',
  'recruiting.candidate.interviewAtNobody': '{when}',
  'recruiting.candidate.rejectedBecause': 'Rejected: {reason}',
  'recruiting.candidate.deletion': 'This candidate and the CV are deleted on {date}.',
  'recruiting.candidate.hired': 'Hired on {date}.',
  'recruiting.candidate.employee': 'Open the employee record',
  'recruiting.rating.title': 'Rating',
  'recruiting.rating.none': 'Not rated yet',
  'recruiting.rating.summary.one': 'Average {average} of 5 from {count} rater',
  'recruiting.rating.summary.other': 'Average {average} of 5 from {count} raters',
  'recruiting.rating.yours': 'Your rating',
  'recruiting.rating.set': 'Rate {rating} of 5',
  'recruiting.rating.saved': 'Rating saved',
  'recruiting.note.title': 'Add a note',
  'recruiting.note.placeholder': 'What you heard, what you think',
  'recruiting.note.add': 'Add note',
  'recruiting.note.saved': 'Note added',
  'recruiting.timeline': 'Timeline',
  'recruiting.timeline.empty': 'Nothing yet',
  'recruiting.timeline.candidate': 'The candidate',
  'recruiting.event.APPLIED': 'Applied',
  'recruiting.event.STAGE_CHANGED': 'Moved from {from} to {to}',
  'recruiting.event.NOTE': 'Note',
  'recruiting.event.RATING': 'Rated {rating} of 5',
  'recruiting.event.HIRED': 'Hired',
  'recruiting.event.interview': 'Interview on {when}',
  'recruiting.event.interviewWith': 'Interview on {when}, with {name}',
  'recruiting.event.reason': 'Reason: {reason}',

  'admin.apiError.CANDIDATE_HIRED': 'This candidate was hired, so they are an employee now.',
  'admin.apiError.CANDIDATE_REJECTED': 'This candidate was rejected. Move them back to a stage before hiring.',
  'admin.apiError.SAME_STAGE': 'The candidate is already at that stage.',
  'admin.apiError.REJECTION_REASON_REQUIRED': 'Say why the candidate is rejected.',
  'admin.apiError.INTERVIEW_DATE_REQUIRED': 'Set when the interview is.',
  'admin.apiError.INTERVIEWER_NOT_ALLOWED': 'An interviewer must be a member of staff who works with candidates.',
  'admin.apiError.INVITE_NEEDS_EMAIL': 'An invitation needs an email address.',
  'admin.apiError.ALREADY_STAFF': 'This person is already on the team. Change their role in Staff instead.',
  'admin.apiError.UNKNOWN_LOCATION': 'That branch is not an open branch of this gym.',
};

export const ka: Record<keyof typeof en, string> = {
  'shell.nav.recruiting': 'რეკრუტინგი',
  'shell.nav.recruitingOpenings': 'ვაკანსიები',
  'shell.nav.recruitingCandidates': 'კანდიდატები',
  'shell.nav.recruitingInterviews': 'ჩემი გასაუბრებები',
  'enum.candidateStage.APPLIED': 'განაცხადი',
  'enum.candidateStage.SCREENING': 'წინასწარი შერჩევა',
  'enum.candidateStage.INTERVIEW': 'გასაუბრება',
  'enum.candidateStage.OFFER': 'შეთავაზება',
  'enum.candidateStage.HIRED': 'აყვანილია',
  'enum.candidateStage.REJECTED': 'უარყოფილია',
  'enum.openingStatus.OPEN': 'ღიაა',
  'enum.openingStatus.CLOSED': 'დახურულია',

  'recruiting.openings.title': 'ვაკანსიები',
  'recruiting.openings.description': 'ღია ვაკანსია გამოჩნდება თქვენი ვებსაიტის კარიერის გვერდზე განაცხადის ფორმით, რომელშიც რეზიუმეს ატვირთვაც შეიძლება.',
  'recruiting.openings.add': 'ახალი ვაკანსია',
  'recruiting.openings.empty': 'ვაკანსიები ჯერ არ არის',
  'recruiting.openings.emptyHint': 'გამოაქვეყნეთ პირველი ვაკანსია და ის გამოჩნდება თქვენი ვებსაიტის კარიერის გვერდზე.',
  'recruiting.opening.job': 'ვაკანსია',
  'recruiting.opening.branch': 'ფილიალი',
  'recruiting.opening.department': 'დეპარტამენტი',
  'recruiting.opening.type': 'დასაქმების ტიპი',
  'recruiting.opening.status': 'სტატუსი',
  'recruiting.opening.candidates': 'კანდიდატები',
  'recruiting.opening.anyBranch': 'ნებისმიერი ფილიალი',
  'recruiting.opening.noDepartment': 'დეპარტამენტის გარეშე',
  'recruiting.opening.candidateCount': 'სულ {total}, პროცესშია {open}',
  'recruiting.opening.noCandidates': 'ჯერ არავინ',
  'recruiting.opening.viewCandidates': 'კანდიდატების ნახვა',
  'recruiting.opening.edit': 'რედაქტირება',
  'recruiting.opening.close': 'ვაკანსიის დახურვა',
  'recruiting.opening.reopen': 'ხელახლა გახსნა',
  'recruiting.opening.created': 'ვაკანსია გამოქვეყნდა',
  'recruiting.opening.saved': 'ვაკანსია შენახულია',
  'recruiting.opening.closed': 'ვაკანსია დაიხურა. განაცხადებს მეტი აღარ იღებს.',
  'recruiting.opening.reopened': 'ვაკანსია ხელახლა გაიხსნა',
  'recruiting.opening.newTitle': 'ახალი ვაკანსია',
  'recruiting.opening.editTitle': 'ვაკანსიის რედაქტირება',
  'recruiting.opening.dialogHint': 'შეავსეთ ორივე ენაზე. ვიზიტორი იმ ენაზე წაიკითხავს, რომელზეც გვერდი უკვე უჭირავს.',
  'recruiting.opening.titleField': 'პოზიციის დასახელება',
  'recruiting.opening.descriptionField': 'აღწერა',
  'recruiting.opening.descriptionHint': 'რას მოიცავს სამუშაო, რა გრაფიკია და რას ითხოვთ კანდიდატისგან.',
  'recruiting.opening.titleRequired': 'მიუთითეთ დასახელება მინიმუმ ერთ ენაზე',
  'recruiting.opening.statusField': 'სტატუსი',
  'recruiting.opening.statusHint': 'ვებსაიტზე გამოჩნდება და განაცხადებს მხოლოდ ღია ვაკანსია იღებს.',

  'recruiting.retention.title': 'განაცხადების შენახვა',
  'recruiting.retention.description': 'უარყოფილი კანდიდატი რეზიუმესთან ერთად წაიშლება ამ ვადის გასვლის შემდეგ. ვინც განხილვაშია და ვინც აყვანილია, არ იშლება.',
  'recruiting.retention.months': 'რამდენ თვეს ინახება უარყოფილი კანდიდატი',
  'recruiting.retention.hint': '1-დან 60 თვემდე. წაშლას ყოველდღიური პროცესი ასრულებს და აუდიტის ჟურნალში ჩაწერს.',
  'recruiting.retention.saved': 'შენახვის ვადა შენახულია',

  'recruiting.candidates.title': 'კანდიდატები',
  'recruiting.candidates.description': 'ყველა, ვინც განაცხადი გამოგზავნა: განაცხადიდან აყვანამდე. ბარათი გადაიტანეთ შემდეგ ეტაპზე.',
  'recruiting.candidates.search': 'ძებნა სახელით, ელფოსტით ან ტელეფონით',
  'recruiting.candidates.allOpenings': 'ყველა ვაკანსია',
  'recruiting.candidates.empty': 'განაცხადები ჯერ არ არის',
  'recruiting.candidates.emptyHint': 'თქვენი ვებსაიტის კარიერის გვერდიდან გამოგზავნილი განაცხადები აქ გამოჩნდება.',
  'recruiting.candidates.noMatch': 'კანდიდატი ვერ მოიძებნა',
  'recruiting.candidates.noMatchHint': 'სცადეთ სხვა საძიებო სიტყვა ან სხვა ვაკანსია.',
  'recruiting.candidates.clear': 'ფილტრების გასუფთავება',
  'recruiting.candidates.descriptionList': 'ყველა, ვინც განაცხადი გამოგზავნა, ახალი განაცხადები — პირველად. კანდიდატის გახსნით ნახავთ განაცხადსა და რეზიუმეს.',
  'recruiting.candidates.allStages': 'ყველა ეტაპი',
  'recruiting.view.label': 'ხედი',
  'recruiting.view.board': 'დაფა',
  'recruiting.view.list': 'სია',
  'recruiting.list.stage': 'ეტაპი',
  'recruiting.list.applied': 'გაგზავნის თარიღი',
  'recruiting.list.deletion': 'წაშლის თარიღი',
  'recruiting.board.label': 'კანდიდატების ეტაპები',
  'recruiting.board.empty': 'აქ არავინაა',
  'recruiting.board.more': 'კიდევ {count} არ ჩანს',
  'recruiting.board.handle': 'გადაიტანეთ: {name}',
  'recruiting.board.instructions': 'კანდიდატის ასაყვანად დააჭირეთ ინტერვალს, ეტაპის ასარჩევად — მარცხენა და მარჯვენა ისრებს, ჩასაგდებად — ისევ ინტერვალს.',
  'recruiting.board.picked': '{name} აყვანილია ეტაპიდან: {stage}.',
  'recruiting.board.over': '{name} არის ეტაპზე: {stage}.',
  'recruiting.board.dropped': '{name} გადავიდა ეტაპზე: {stage}.',
  'recruiting.board.cancelled': '{name} რჩება ეტაპზე: {stage}.',
  'recruiting.card.interview': 'გასაუბრება: {when}',
  'recruiting.card.rating': '{rating} / 5',
  'recruiting.card.cv': 'რეზიუმე ახლავს',
  'recruiting.card.deletedOn': 'წაიშლება: {date}',
  'recruiting.moved': '{name} გადავიდა ეტაპზე: {stage}',

  'recruiting.interviews.title': 'ჩემი გასაუბრებები',
  'recruiting.interviews.description': 'კანდიდატები, რომლებთან გასაუბრებაზეც თქვენ ხართ დანიშნული. გახსენით კანდიდატი განაცხადისა და რეზიუმეს სანახავად.',
  'recruiting.interviews.empty': 'გასაუბრებები ჯერ არ არის',
  'recruiting.interviews.emptyHint': 'როცა ვინმე თქვენ დაგნიშნავთ კანდიდატის გამსაუბრებლად, ეს კანდიდატი აქ გამოჩნდება.',
  'recruiting.interviews.noDate': 'თარიღი არ არის მითითებული',
  'recruiting.interviews.noCv': 'რეზიუმე არ ახლავს',
  'recruiting.interviews.back': 'ჩემს გასაუბრებებზე დაბრუნება',

  'recruiting.reject.title': 'უარის თქმა: {name}',
  'recruiting.reject.description': 'მიზეზი დარჩება კანდიდატის ისტორიაში. მისი მონაცემები და რეზიუმე წაიშლება {months} თვეში.',
  'recruiting.reject.label': 'მიზეზი',
  'recruiting.reject.placeholder': 'რატომ არ გრძელდება პროცესი',
  'recruiting.reject.confirm': 'უარის თქმა',
  'recruiting.interview.title': 'გასაუბრება: {name}',
  'recruiting.interview.description': 'მიუთითეთ, როდის იმართება და ვინ ესაუბრება.',
  'recruiting.interview.when': 'თარიღი და დრო',
  'recruiting.interview.who': 'გამსაუბრებელი',
  'recruiting.interview.nobody': 'ჯერ არ არის გადაწყვეტილი',
  'recruiting.interview.confirm': 'გასაუბრების შენახვა',
  'recruiting.interview.change': 'გასაუბრების შეცვლა',

  'recruiting.hire.action': 'აყვანა',
  'recruiting.hire.title': 'აყვანა: {name}',
  'recruiting.hire.description': 'ეს დაამატებს მას განყოფილებაში „გუნდი → თანამშრომლები“. მონაცემები აღებულია განაცხადიდან და ვაკანსიიდან; გადაამოწმეთ.',
  'recruiting.hire.required': 'სავალდებულოა',
  'recruiting.hire.firstName': 'სახელი',
  'recruiting.hire.lastName': 'გვარი',
  'recruiting.hire.position': 'პოზიცია',
  'recruiting.hire.department': 'დეპარტამენტი',
  'recruiting.hire.noDepartment': 'დეპარტამენტის გარეშე',
  'recruiting.hire.branch': 'ფილიალი',
  'recruiting.hire.everyBranch': 'ყველა ფილიალი',
  'recruiting.hire.type': 'დასაქმების ტიპი',
  'recruiting.hire.startDate': 'მუშაობის დაწყების თარიღი',
  'recruiting.hire.invite': 'სისტემაში შესვლაზეც მოვიწვიოთ',
  'recruiting.hire.inviteHint': 'მიიღებს ელფოსტას, რომ ამ დარბაზში ანგარიში შექმნას ქვემოთ მითითებული როლით.',
  'recruiting.hire.inviteNeedsEmail': 'მოსაწვევად ელფოსტის მისამართია საჭირო.',
  'recruiting.hire.role': 'როლი',
  'recruiting.hire.branches': 'მუშაობს ფილიალებში',
  'recruiting.hire.branchRequired': 'აირჩიეთ მინიმუმ ერთი ფილიალი',
  'recruiting.hire.confirm': 'აყვანა',
  'recruiting.hire.done': '{name} უკვე თანამშრომელია.',
  'recruiting.hire.openEmployee': 'თანამშრომლის გახსნა',
  'recruiting.hire.inviteSent': 'მოსაწვევი ელფოსტით გაიგზავნა. ეს ბმული შეგიძლიათ თავადაც გაუგზავნოთ.',
  'recruiting.hire.attached': 'მას ამ დარბაზში უკვე ჰქონდა ანგარიში, ამიტომ როლი დაუყოვნებლივ მიენიჭა.',

  'recruiting.candidate.back': 'კანდიდატებზე დაბრუნება',
  'recruiting.candidate.moveTo': 'გადატანა ეტაპზე',
  'recruiting.candidate.appliedFor': 'ვაკანსია: {job}, განაცხადი: {date}',
  'recruiting.candidate.application': 'განაცხადი',
  'recruiting.candidate.message': 'შეტყობინება',
  'recruiting.candidate.noMessage': 'შეტყობინება არ დაუწერია.',
  'recruiting.candidate.consent': 'დათანხმდა, რომ დარბაზი შეინახავს მის მონაცემებს: {date}.',
  'recruiting.candidate.cv': 'რეზიუმე',
  'recruiting.candidate.noCv': 'რეზიუმე არ გამოუგზავნია.',
  'recruiting.candidate.openCv': 'რეზიუმეს გახსნა',
  'recruiting.candidate.cvNote': 'იხსნება პირადი ბმული, რომელიც ხუთი წუთის განმავლობაში მოქმედებს. გახსნა აუდიტის ჟურნალში ფიქსირდება.',
  'recruiting.candidate.cvFailed': 'რეზიუმე ვერ გაიხსნა',
  'recruiting.candidate.interview': 'გასაუბრება',
  'recruiting.candidate.interviewAt': '{when}, გამსაუბრებელი: {name}',
  'recruiting.candidate.interviewAtNobody': '{when}',
  'recruiting.candidate.rejectedBecause': 'უარი: {reason}',
  'recruiting.candidate.deletion': 'ეს კანდიდატი და რეზიუმე წაიშლება: {date}.',
  'recruiting.candidate.hired': 'აყვანილია: {date}.',
  'recruiting.candidate.employee': 'თანამშრომლის ჩანაწერის გახსნა',
  'recruiting.rating.title': 'შეფასება',
  'recruiting.rating.none': 'ჯერ არ არის შეფასებული',
  'recruiting.rating.summary.one': 'საშუალო {average} / 5, შემფასებელი: {count}',
  'recruiting.rating.summary.other': 'საშუალო {average} / 5, შემფასებელი: {count}',
  'recruiting.rating.yours': 'თქვენი შეფასება',
  'recruiting.rating.set': 'შეფასება: {rating} / 5',
  'recruiting.rating.saved': 'შეფასება შენახულია',
  'recruiting.note.title': 'შენიშვნის დამატება',
  'recruiting.note.placeholder': 'რა მოისმინეთ და რას ფიქრობთ',
  'recruiting.note.add': 'შენიშვნის დამატება',
  'recruiting.note.saved': 'შენიშვნა დაემატა',
  'recruiting.timeline': 'ისტორია',
  'recruiting.timeline.empty': 'ჯერ არაფერია',
  'recruiting.timeline.candidate': 'კანდიდატი',
  'recruiting.event.APPLIED': 'გამოგზავნა განაცხადი',
  'recruiting.event.STAGE_CHANGED': 'გადავიდა ეტაპიდან „{from}“ ეტაპზე „{to}“',
  'recruiting.event.NOTE': 'შენიშვნა',
  'recruiting.event.RATING': 'შეფასება: {rating} / 5',
  'recruiting.event.HIRED': 'აყვანილია',
  'recruiting.event.interview': 'გასაუბრება: {when}',
  'recruiting.event.interviewWith': 'გასაუბრება: {when}, გამსაუბრებელი: {name}',
  'recruiting.event.reason': 'მიზეზი: {reason}',

  'admin.apiError.CANDIDATE_HIRED': 'ეს კანდიდატი უკვე აყვანილია, ამიტომ ახლა თანამშრომელია.',
  'admin.apiError.CANDIDATE_REJECTED': 'ეს კანდიდატი უარყოფილია. აყვანამდე დააბრუნეთ რომელიმე ეტაპზე.',
  'admin.apiError.SAME_STAGE': 'კანდიდატი უკვე ამ ეტაპზეა.',
  'admin.apiError.REJECTION_REASON_REQUIRED': 'მიუთითეთ, რატომ ეუბნებით კანდიდატს უარს.',
  'admin.apiError.INTERVIEW_DATE_REQUIRED': 'მიუთითეთ გასაუბრების დრო.',
  'admin.apiError.INTERVIEWER_NOT_ALLOWED': 'გამსაუბრებელი უნდა იყოს თანამშრომელი, რომელიც კანდიდატებთან მუშაობს.',
  'admin.apiError.INVITE_NEEDS_EMAIL': 'მოსაწვევად ელფოსტის მისამართია საჭირო.',
  'admin.apiError.ALREADY_STAFF': 'ეს ადამიანი უკვე გუნდშია. როლი შეცვალეთ განყოფილებაში „პერსონალი“.',
  'admin.apiError.UNKNOWN_LOCATION': 'ეს ფილიალი ამ დარბაზის მოქმედი ფილიალი არ არის.',
};
